export const IMAGE_ATTACHMENT_TYPES = ['image'];
export const MERMAID_ATTACHMENT_TYPES = ['pie', 'timeline', 'mindmap', 'flowchart', 'xychart-beta', 'quadrantChart'];
